<div style="border: 1px solid lightgray; padding: 20px; margin-bottom: 10px">
  <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px">
    <h4 style="color: black">{{pageSummary.title}}</h4>
    <button class="btn btn-primary btn-assessor" (click)="handleModifyClick()" [disabled]="pageSummary.disableModifyButton">Modify</button>
  </div>

  @for (field of pageSummary.fields; track field.label; let i = $index) {
    <div [style.background-color]="i % 2 === 0 ? '#e6e6e6' : 'GhostWhite'">
      <div style="padding: 10px; display: flex; align-items: center">
        <div class="col-6">
          <p style="color: black; margin-bottom: 0"><b>{{field.label}}</b></p>
        </div>
        <div class="col-6">
          <p style="color: black; margin-bottom: 0; word-wrap: break-word">{{field.value}}</p>
        </div>
      </div>
      @if (i !== pageSummary.fields.length - 1) {
        <hr style="margin-bottom: 0; margin-top: 0">
      }
    </div>
  }
</div>
